import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=19aaef3a"
import script from "./InfoDialog.vue?vue&type=script&lang=js"
export * from "./InfoDialog.vue?vue&type=script&lang=js"
import style0 from "./InfoDialog.vue?vue&type=style&index=0&id=19aaef3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports